module.exports = __webpack_public_path__ + "img/companyWx.57f99779.png";